import React from 'react';
import { Grid, Button, Icon } from 'semantic-ui-react';

const BackButton = (props) => {
	return (
		<Grid.Row>
			<Button
				icon
				circular
				style={{ background: 'transparent', color: '#003366', padding: 0 }}
			>
				<Icon
					name="arrow left"
					onClick={() => props.history.push(`/${props.returnLocation}`)}
				/>
			</Button>
			<p
				onClick={() => props.history.push(`/${props.returnLocation}`)}
				style={{ fontSize: 14, color: '#075185', fontWeight: 'bold', cursor: 'pointer', marginLeft: '10px' }}
			>
				Back to {props.returnName}
			</p>
		</Grid.Row>
	);
};

export default BackButton;
